












import {Component, Provide, Vue, Prop, Watch} from 'vue-property-decorator';
import {computed} from 'types/vue-toast-notification';
/*Button component for project
  prop: title = title of button
  prop: onClick = onClickHandler
  prop: loading = for showing loading
  prop: btnTypeClass : Optionl = default button btn-primary
*/
@Component
export default class CButton extends Vue {
  @Prop() title: string;
  @Prop() onClick: any;
  @Prop() loading: boolean;
  @Prop() btnTypeClass: string;

  buttonTitle = 'Submit';
  btnclass = 'btn-primary';
  buttonLoading = false;

  @Watch('title', {immediate: true})
  titleChanged(newValue: string, oldValue: string) {
    if (newValue) this.buttonTitle = newValue;
  }
  @Watch('btnTypeClass', {immediate: true})
  classesChanged(newValue: string, oldValue: string) {
    if (newValue) this.btnclass = newValue;
  }

  @Watch('loading', {immediate: true})
  stateChanged(newValue: boolean, oldValue: boolean) {
    this.buttonLoading = newValue;
    if (this.buttonLoading == null) this.buttonLoading = false;
  }

  onButtonClick() {
    if (this.onClick) this.onClick();
  }
}
